export function generateInitial(firstName: string = '', lastName: string = '') {
  const firstNameInitial = firstName[0] || ''
  const lastNameWords = lastName.split(' ')
  const lastNameInitial = lastNameWords[lastNameWords.length - 1][0] || ''

  return firstNameInitial + lastNameInitial || 'W'
}
